export default __webpack_public_path__ + "04d8e885c6fdd685c59a21dbe7b1241b.png";